import React from 'react';
import type { MessageState } from '../types';
import { MESSAGE_CLASSES } from '../constants';

interface MessageBannerProps {
  message: MessageState | null;
}

export const MessageBanner: React.FC<MessageBannerProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className={`mb-4 rounded-lg border px-3 py-2 text-sm ${MESSAGE_CLASSES[message.type]}`}>
      {message.text}
    </div>
  );
};
